import React from 'react';

import styled, {keyframes} from 'styled-components';
import {isEmpty} from "../../../util";

interface ContentsProps {
    title: any;
    children: React.ReactElement;
    maxWidth?:number
}

const fadeIn = keyframes`
  from {
    transform: translateY(-10px); /* 위에서 내려오는 효과를 줍니다. */
    opacity: 0; /* 투명도를 0으로 설정하여 처음에는 보이지 않도록 합니다. */
  }

  to {
    transform: translateY(0); /* 위치를 변화시켜 아래로 이동합니다. */
    opacity: 1; /* 투명도를 1로 설정하여 완전히 보이도록 합니다. */
  }
`;
const Contents = (props) => {
    const textTransform = (text: string) => {
        switch (text) {
            case "learning material": {
                return "Learning material";
            }
            case "Q n As" : {
                return "Q n As"
            }
            default: {
                return <TitleText>{text}</TitleText>;
            }
        }
    };
    return (
        <Container className={`commonContents timeContents ${props?.className || ""}`}>
            {
                !isEmpty(props?.title) &&
                <ContentsHeader className={"commonContentsHeader"}>{textTransform(props?.title)}</ContentsHeader>
            }
            {props?.children}
            
        </Container>
    );
};
export { Contents };

const Container = styled.div`
    max-width: 1048px;
    position: relative;
    animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    flex: 1;
    background: #fff;
    border-radius:20px 20px 15px 15px!important;
    //overflow: hidden;
    &.popup{
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);    
    }
    box-shadow: 0px 0px 10px 0px #ddc16080;
    
`;

const ContentsHeader = styled.div`
    background: #333;
    padding: 13.4px 24px;
    overflow: hidden;
    color: #ddc160;
    letter-spacing: 0em;
    text-align: left;
    border-radius: 14px 14px 0 0;
 
`;

const TitleText = styled.span`
    text-transform: capitalize;
    font-family: "Europa-Bold"!important;
    font-size: 22px;
    line-height: 22px;
    font-weight: 700;
`;
